import { render } from "./QualificationDropdown.vue?vue&type=template&id=077f0636"
import script from "./QualificationDropdown.vue?vue&type=script&lang=js"
export * from "./QualificationDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__